import { ValueType } from '@nibras/core/common';
import { dcDataStoreItem } from './datastore-item.model';
import { dcAttributeHeader } from './dcattribute.model';
import { dcExternalParameter, QueryOperation } from './request/request.model';

export class dcAttributeLite {
  public ParentAttributeID: number;
  public AttributeTemplateName: string;
  public ElementVersionID: number;
  public ElementName: string;
  public Precision: number;
  public UOMID: number;
  public RootElementName: string;
  public RootElementVersionID: number;
  public AttributeID: number; //This is used only in case of DataExplorer. Need to use a new model for DataExplorer.
  public ValueTypeID: ValueType; // This valueTypeID is same as in attribute - So it can be merged.
  public AttributePath: string; // This ElementPath is NULL in attribute, so we can use this ElementPath itself.
  public PrimitiveValueTypeID: ValueType;
  public ElementPath: string;

  constructor() {}

  public static fromAttributeDataKey(dataKey: dcAttributeDataKey): dcAttributeHeader {
    return dataKey as dcAttributeLite as dcAttributeHeader;
  }
}

export class dcAttributeDataKey extends dcAttributeLite implements dcDataStoreItem {
  Key: string;
  public DataComponentID: number;
  public DataComponentName: string;
  public AttributeDataKey: string;
  public ParentAttributeDataKey: string;
  //Not need to send this from Server, this is used only to send modified ExternalParameters from Client to server.
  public ExternalParameter: dcExternalParameter;
  public ComponentParameter: dcExternalParameter;
  public IsReferenceTimeDataComponent: boolean;
  public ProcessInstanceID: number;
  public ActualRootElementVersionID: number;
  // This need to be fixed for save atttribute value feature to work.
  public attributeTemp: dcAttributeHeader;
  public isPublished: boolean;
  public ChildElementVersionID: number;
  public ChildElementPath: string;
  public RootCauseElementPath: string;
  public QueryID: number;
  public QueryOperation: QueryOperation;
  public QueryOrder: number;
  public QueryManagerID: number;
  public SupportsLookup: boolean;
  public ElementTypeName: string;
  public ActivityInstanceID: number;
}
